import { Injectable } from '@angular/core';

import { Flags } from '@shared/services/launch-darkly.service';

import { BasicSettingsGuard } from './basic-settings.guard';

@Injectable({ providedIn: 'root' })
export class UserPermissionsGuard extends BasicSettingsGuard {
  featureFlag = 'tab_user_permissions' as keyof Flags;
}

@Injectable({ providedIn: 'root' })
export class IntegrationsGuard extends BasicSettingsGuard {
  featureFlag = 'tab_integrations' as keyof Flags;
}

@Injectable({ providedIn: 'root' })
export class ExchangeRatesGuard extends BasicSettingsGuard {
  featureFlag = 'tab_exchange_rates' as keyof Flags;
}

@Injectable({ providedIn: 'root' })
export class ExpenseDefaultsGuard extends BasicSettingsGuard {
  featureFlag = 'expense_defaults' as keyof Flags;
}

@Injectable({ providedIn: 'root' })
export class CloseSettingsGuard extends BasicSettingsGuard {
  featureFlag = 'close_settings' as keyof Flags;
}

@Injectable({ providedIn: 'root' })
export class JEConfigurationGuard extends BasicSettingsGuard {
  featureFlag = 'settings_journal_entry_configuration' as keyof Flags;
}

@Injectable({ providedIn: 'root' })
export class StudySpecificationsGuard extends BasicSettingsGuard {
  featureFlag = 'tab_forecast_studyspecifications' as keyof Flags;
}

@Injectable({ providedIn: 'root' })
export class BalanceSheetAccountsGuard extends BasicSettingsGuard {
  featureFlag = 'balance_sheet_accounts' as keyof Flags;
}

@Injectable({ providedIn: 'root' })
export class EdcMappingGuard extends BasicSettingsGuard {
  featureFlag = 'tab_investigator_settings' as keyof Flags;
}
